import styled, { css } from 'styled-components';

import { ReactComponent as WaveSVG } from 'Public/graphics/waves/promo-point/ben-search/wave-ben-search.svg';

export const Heading = styled.h1`
    ${({ theme }) => css`
        margin: 0;
        padding-top: 3.5rem;

        @media ${theme.breakpoints.large.media} {
            padding-top: 5rem;
        }
    `}
`;

export const SectionNavWrapper = styled.div`
    ${({ theme }) => css`
        padding-top: 1rem;

        @media ${theme.breakpoints.medium.media} {
            padding-top: 0;
            text-align: right;
        }
    `}
`;

export const WaveWrapper = styled.div`
    ${({ theme }) => css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;

        :before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            background: transparent
                linear-gradient(
                    180deg,
                    transparent 0%,
                    ${theme.colors.secondary.tints[1].hex}00 44%,
                    ${theme.colors.secondary.tints[1].hex}a6 65%,
                    ${theme.colors.secondary.tints[1].hex}ce 85%,
                    ${theme.colors.secondary.tints[1].hex} 100%
                );
        }
    `}
`;

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: relative;
        height: 100%;
        width: auto;
        top: 0;

        @media ${theme.breakpoints.medium.media} {
            width: 120%;
        }

        @media ${theme.breakpoints.large.media} {
            height: auto;
            left: -5rem;
        }
    `}
`;
